import React, { useState } from "react";
import { Box, Typography, Divider, Stack, Link } from "@mui/material";
import isValid from "date-fns/isValid";
import { ChangeRequest } from "../../../../types/brm/request-types";
import { FormattedMessage, useIntl } from "react-intl";
import { EntityFormHeaderTitle } from "../../../common/entity-form";
import { Button } from "../../../common/buttons";
import SetRequestStageDialog from "./set-request-stage-dialog";

const LabelValue: React.FC<{ label: React.ReactNode; value: string }> = ({ label, value }) => (
    <Typography variant="body2">
        <Typography sx={{ fontWeight: "400", fontSize: "12px", color: "#686868" }} component="span">
            {label}{" "}
        </Typography>{" "}
        <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#363636" }} component="span">
            {value}
        </Typography>
    </Typography>
);

type RequestDetailedHeaderTitleProps = {
    requestData: ChangeRequest | null;
    onBackClick: () => void;
    hasManualApproveBtn: boolean;
};

const RequestDetailedHeaderTitle: React.FC<RequestDetailedHeaderTitleProps> = ({ requestData, onBackClick, hasManualApproveBtn }) => {
    const intl = useIntl();
    const [isSetStageDialogOpen, setIsSetStageDialogOpen] = useState(false);

    const dateFormater = (value: string) => {
        const date = new Date(value);

        return isValid(date)
            ? intl.formatDate(date, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
              })
            : "";
    };

    return (
        <Box className="request-detailed-header-title" display="flex" alignItems="center" justifyContent="space-between">
            <EntityFormHeaderTitle title={intl.formatMessage({ id: "request-detailed-header-title.title" }, { requestId: requestData?.requestId })} onBackClick={onBackClick} />
            {hasManualApproveBtn && (
                <Button
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                    onClick={() => setIsSetStageDialogOpen(true)}
                >
                    <FormattedMessage id="request-detailed-header-title.select-request-stage" />
                </Button>
            )}
            <Stack className="request-detailed-header-request-info" direction="row" divider={<Divider orientation="vertical" flexItem sx={{ margin: "0" }} />}>
                <LabelValue label={<FormattedMessage id="request-detailed-header-title.outer-id" />} value={requestData?.requestId.toString() || ""} />
                <Link href={requestData?.url} target="_blank" variant="body2" sx={{ color: "#363636", textDecorationColor: "#363636" }}>
                    <FormattedMessage id="request-detailed-header-title.request-url" />
                </Link>
                <LabelValue label={<FormattedMessage id="request-detailed-header-title.created-by" />} value={requestData?.createdByText ?? ""} />
                <SetRequestStageDialog open={isSetStageDialogOpen} onClose={() => setIsSetStageDialogOpen(false)} />
                <LabelValue label={<FormattedMessage id="request-detailed-header-title.request-creation-date" />} value={dateFormater(requestData?.createdAt ?? "")} />
            </Stack>
        </Box>
    );
};

export default RequestDetailedHeaderTitle;
